import SecurityIcon from "@mui/icons-material/Security";
import WarningIcon from "@mui/icons-material/Warning";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CampaignIcon from "@mui/icons-material/Campaign";
import ReceiptIcon from '@mui/icons-material/Receipt';
import DescriptionIcon from '@mui/icons-material/Description';
import PrintIcon from '@mui/icons-material/Print';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import EmailIcon from "@mui/icons-material/Email";
import InventoryIcon from "@mui/icons-material/Inventory";
import SearchIcon from "@mui/icons-material/Search";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import SellIcon from "@mui/icons-material/Sell";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";


export const routes = [
  {
    path: "/",
    label: "דף הבית",
    accessRight: "HomePage",
    showInNav: true,
    showInHomePage: false
  },
  {
    path: "/ApproveLines",
    label: "שחרור הזמנות בהשהיית סחר",
    accessRight: "AproveLinesPage",
    icon: LocalShippingIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#4B9FD1",
    gradient: "#ebf7ff",
    shadowColor: "rgba(108, 174, 217, 0.2)"
  },
  {
    path: "/TradeDelay",
    label: "השהיות סחר",
    accessRight: "TradeDelayPage",
    icon: PauseCircleOutlineIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#E53935",
    gradient: "linear-gradient(135deg, #FFEBEE 0%, #FFCDD2 100%)",
    shadowColor: "rgba(229, 57, 53, 0.2)"
  },
  {
    path: "/ObligoException",
    label: "חריגת אובליגו",
    accessRight: "ObligoExceptionPage",
    icon: WarningIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#FF9800",
    gradient: "linear-gradient(135deg, #FFF7E6 0%, #FFE0B3 100%)",
    shadowColor: "rgba(255, 183, 77, 0.2)"
  },
  {
    path: "/CheckInvoices",
    // label: "ניתוח חשבוניות AI",
    label: "AI-DocuCheck",
    accessRight: "CheckInvoicesPage",
    icon: ReceiptIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#9575CD", // purple
    gradient: "linear-gradient(135deg, #F5F0FB 0%, #DED1F3 100%)",
    shadowColor: "rgba(149, 117, 205, 0.2)"
  },
  {
    path: "/SalesPromotions",
    label: 'קד"מ ודוגמיות',
    accessRight: "SalesPromotionsPage",
    icon: CampaignIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#F4511E",
    gradient: "linear-gradient(135deg, #FFEDEA 0%, #FFD7D2 100%)",
    shadowColor: "rgba(255, 138, 101, 0.2)"
  },
  {
    path: "/PurchaseInvoice",
    label: 'חשבוניות רכש',
    accessRight: "PurchaseInvoicePage",
    icon: DescriptionIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#4CAF50",
    gradient: "linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)",
    shadowColor: "rgba(76, 175, 80, 0.2)"
  },
  {
    path: "/ChemoRecords",
    label: 'רשומות כימו',
    accessRight: "ChemoRecordsPage",
    icon: LocalHospitalIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#00BCD4",
    gradient: "linear-gradient(135deg, #E0F7FA 0%, #B2EBF2 100%)",
    shadowColor: "rgba(0, 188, 212, 0.2)"
  },
  {
    path: "/agent-complaints",
    label: "תלונות סוכן",
    accessRight: "AgentComplaintsPage",
    icon: SupportAgentIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#E53935",
    gradient: "linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%)",
    shadowColor: "rgba(229, 57, 53, 0.2)"
  },
  {
    path: "/Permissions",
    label: "הרשאות גישה",
    accessRight: "PermissionsPage",
    icon: SecurityIcon,
    showInNav: true,
    showInHomePage: false,
    iconColor: "#81C784",
    gradient: "linear-gradient(135deg, #F2FAF3 0%, #D7EDD8 100%)",
    shadowColor: "rgba(129, 199, 132, 0.2)"
  },
  {
    path: "/TimeLine",
    label: "לוגים",
    accessRight: "TimeLinePage",
    icon: SecurityIcon,
    showInNav: true,
    showInHomePage: false,
    iconColor: "#81C784",
    gradient: "linear-gradient(135deg, #F2FAF3 0%, #D7EDD8 100%)",
    shadowColor: "rgba(129, 199, 132, 0.2)"
  },
  {
    path: "/EldanPrinter",
    label: "🏷️ מדפסת תוויות DYMO",
    accessRight: "EldanPrinterPage",
    icon: PrintIcon,
    showInNav: true,
    showInHomePage: false,
    iconColor: "#FF9800",
    gradient: "linear-gradient(135deg, #FFF7E6 0%, #FFE0B3 100%)",
    shadowColor: "rgba(255, 183, 77, 0.2)"
  },
  {
    path: "/QrCodeDeviceMapping",
    label: "מיפוי מכשירים QR",
    accessRight: "QrCodeDeviceMappingPage",
    icon: QrCodeScannerIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#0563B0",
    gradient: "linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)",
    shadowColor: "rgba(5, 99, 176, 0.2)"
  },
  {
    id: "promotions-system",
    label: "מערכת מבצעים",
    accessRight: "PromotionsSystemPage",
    icon: SellIcon,
    showInNav: true,
    showInHomePage: true,
    iconColor: "#D97706",
    gradient: "linear-gradient(135deg, #FFFBEB 0%, #FDE68A 100%)",
    shadowColor: "rgba(217, 119, 6, 0.3)",
    isExternal: true,
    externalUrl: process.env.REACT_APP_PROMOTIONS_URL,
    openInNewTab: false
  },
  {
    id: "import-management",
    label: "לוגי ייבוא",
    accessRight: "ImportManagementPage",
    icon: InventoryIcon,
    showInNav: false,
    showInHomePage: true,
    iconColor: "#0ea5e9",
    gradient: "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)",
    shadowColor: "rgba(14, 165, 233, 0.3)",
    isExternal: true,
    externalUrl: `${process.env.REACT_APP_AUTOMATIONS}/ImportLogs`,
    openInNewTab: false
  },
  {
    id: "email-tracking",
    label: "מעקב מיילים",
    accessRight: "emailTrackingPage",
    icon: EmailIcon,
    showInNav: false,
    showInHomePage: true,
    iconColor: "#f97316",
    gradient: "linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%)",
    shadowColor: "rgba(249, 115, 22, 0.3)",
    isExternal: true,
    externalUrl: `${process.env.REACT_APP_AUTOMATIONS}/EmailTracking`,
    openInNewTab: false
  },
{
  id: "research-monitor",
  label: "סוכן הזדמנויות אלדן",
  accessRight: "ResearchMonitorPage",
  icon: SearchIcon,
  showInNav: true,
  showInHomePage: true,
  iconColor: "#f472b6",
  gradient: "linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%)",
  shadowColor: "rgba(219, 51, 138, 0.49)",
  isExternal: true,
  externalUrl: process.env.REACT_APP_RESEARCH_MONITOR_URL,
  openInNewTab: false
},
{
  id: "fuel-control",
  label: "בקרת תדלוקים",
  accessRight: "FuelControlPage",
  icon: LocalGasStationIcon,
  showInNav: true,
  showInHomePage: true,
  iconColor: "#cd2fdb",
  gradient: "linear-gradient(135deg, #fdf2fc 0%, #fce7f3 100%)",
  shadowColor: "hsla(295, 59%, 54%, 0.73)",
  isExternal: true,
  externalUrl: process.env.REACT_APP_FUEL_CONTROL_URL,
  openInNewTab: false
},
{
  id: "HR-CV-Matching",
  label: "התאמת קורות חיים למשרות",
  accessRight: "HRCVMatchingPage",
  icon: PersonSearchIcon,
  showInNav: true,
  showInHomePage: true,
  iconColor: "#0891b2",
  gradient: "linear-gradient(135deg, #ecfeff 0%, #cffafe 100%)",
  shadowColor: "rgba(8, 145, 178, 0.35)",
  isExternal: true,
  externalUrl: process.env.REACT_APP_HR_MATCH_CV,
  openInNewTab: false
},


  // דוגמה לקישור חיצוני:
  // {
  //   path: "/external-app",
  //   label: "אפליקציה חיצונית",
  //   accessRight: "ExternalAppPage",
  //   icon: SecurityIcon,
  //   showInNav: true,
  //   showInHomePage: false,
  //   iconColor: "#FF5722",
  //   gradient: "linear-gradient(135deg, #FFEBEE 0%, #FFCDD2 100%)",
  //   shadowColor: "rgba(255, 87, 34, 0.2)",
  //   isExternal: true,
  //   externalUrl: "https://example.com",
  //   openInNewTab: true  // אופציונלי - פתיחה בטאב חדש
  // }

];

export const getFilteredRoutes = (userAccessRights) => {
  return routes.filter(route =>
    route.showInNav && userAccessRights && userAccessRights[route.accessRight]
  );
};

export const getDashboardCards = (userAccessRights) => {
  console.log('getDashboardCards called with:', userAccessRights);
  
  const filtered = routes.filter(route => {
    const hasAccess = userAccessRights?.admin 
      ? route.showInHomePage 
      : (route.showInHomePage && userAccessRights && userAccessRights[route.accessRight]);
    
    if (route.accessRight === 'ResearchMonitorPage') {
      console.log('Research Monitor Card:', { 
        hasAccess, 
        showInHomePage: route.showInHomePage,
        accessRight: route.accessRight,
        userHasRight: userAccessRights?.[route.accessRight],
        isAdmin: userAccessRights?.admin
      });
    }
    
    return hasAccess;
  });

  console.log('Filtered cards:', filtered.map(r => r.label));
  return filtered;
};
